import React from 'react';
import { useRouteError } from 'react-router-dom';
import { FallbackErrorPage } from '@prometheus/features';

export const RouterErrorBoundary = () => {
  let error = useRouteError();
  console.error(error);
  // Uncaught ReferenceError: path is not defined
  return (
    <FallbackErrorPage
      status={42}
      statusText="Answer to the Ultimate Question of Life, The Universe, and Everything"
    />
  );
};
